import React, {useState} from 'react';
import AddressFrm from '../../../Shared/AddressFrm/AddressFrm';
import {Row, Col} from 'reactstrap';

const SetUpAddress = (props) => {
  const [submit, setSubmit] = useState(false);

  const handleSubmit = () => {
    setSubmit(true);
  };

  const handleAddressValidate = (isValid) => {
    if (isValid) {
      let address = props.addressData.form;
    }

    setSubmit(false);
  };

  return (
    <div className='container-fluid main'>
      <div className='setup-address'>
        <Row>
          <Col ms={12}>
            <h1 className='main-title'>{props.title}</h1>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <h1 className='top-title'>{props.subTitle}</h1>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <p className='top-link'>{props.linkText}</p>
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <AddressFrm onValid={handleAddressValidate} onSubmit={submit} />
          </Col>
        </Row>
        <Row>
          <Col ms={12}>
            <div style={{padding: '10px', paddingRight: '15px', paddingLeft: '15px'}}>
              {}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SetUpAddress;
